import 'css-chunk:src/components/widgets/Table/Cell/Editable/NumberEditInput.scss';export default {
  "input": "_input_19l9q_1"
};